module.exports = __webpack_public_path__ + "static/media/tab-block.039fedc1.jpg";